
<template>
    <div class="center">
        <div>
            <vs-button
                :disabled="!selected.length"
                success
                flat
                class="ml-auto"
                @click="activeAsignar =! activeAsignar"
            >
                Asignar beca
            </vs-button>
        </div>
      <vs-table
        v-model="selected"
        >
        <template #thead>
            <vs-tr>
                <vs-th style="width: 10%;">
                    <vs-checkbox
                        :indeterminate="selected.length == becas.length" v-model="allCheck"
                        @change="selected = $vs.checkAll(selected, becas)"
                    />
                </vs-th>
                <vs-th>
                    Académico
                </vs-th>
                <vs-th>
                    Beca
                </vs-th>
                <vs-th>
                    Tipo
                </vs-th>
            </vs-tr>
        </template>
        <template #tbody>
            <vs-tr
                :key="i"
                v-for="(tr, i) in becas"
                :data="tr"
                :is-selected="!!selected.includes(tr)"
                class="divisionLineas"
            >
                <vs-td checkbox>
                <vs-checkbox :val="tr" v-model="selected" />
                </vs-td>
                <vs-td>
                    <p class="mb-0"><small>NOMBRE</small></p>
                    <p><strong>{{ tr.nombre }}</strong></p>
                    <p class="mb-0"><small>MATRÍCULA</small></p>
                    <p><strong>{{ tr.matricula }}</strong></p>
                </vs-td>
                <vs-td>
                    <p><strong>{{ tr.becas }}</strong></p>
                </vs-td>
                <vs-td>
                    <md-chip :class="'mini-chip col-' + statusColores[tr.tipo]['color']"><strong>{{statusColores[tr.tipo]['abv']}}</strong></md-chip>
                </vs-td>
            </vs-tr>
        </template>
        <template #notFound>
            Sin información
        </template>
      </vs-table>
    <modal-asignar-beca v-model="activeAsignar" :selected="selected" :institucion="institucion" :cicloEscolar="cicloEscolar" @refreshTabla="getRefresh"></modal-asignar-beca>
    </div>
</template>
<script>
import ModalAsignarBeca from './modal/asignar-beca.vue'
export default {
    props: [
        'becas',
        'institucion',
        'cicloEscolar',
        'grupo'
    ],
    data:() => ({
        allCheck: false,
        selected: [],
        statusColores: {
            "alumno": {
                "color" : "green",
                "abv" : "ALUMNO"
            },
            "prospecto": {
                "color" : "blue",
                "abv" : "PROSPECTO"
            },
        },
        activeAsignar: false
    }),
    components: {
        ModalAsignarBeca
    },
    methods:{
        getRefresh(){
            this.selected = []
            this.$emit('refreshTabla')
        }
    },
    watch:{
        becas(){
            this.selected = []
        }
    }
}
</script>
<style>
    .divisionLineas:not(:last-child){
        border-bottom: 1px solid #E5E7E9; 
    }
    .divisionLineas{
        padding: 2% 0;
    }
</style>

<style lang="scss" scoped>
.mini-icon {
     font-size: 0.7rem !important;
}

@mixin text-colors ($theme, $text-color, $background) {
    &.col-#{$theme}{
        color: $text-color !important;
        background-color: $background !important;
    }
}

.md-chip{
    &.mini-chip{
        height: 21px;
        padding: 0px 5px;
        font-size: 12px;
        line-height: 23px;
    }
    @include text-colors ('green', #55ce63, #e8fdeb);
    @include text-colors ('none', #080808, transparent);
    @include text-colors ('red', #f62d51, #f9e7eb); 
    @include text-colors ('yellow', #febf3d, #fff8ec); 
    @include text-colors ('blue', #37aefb, #cfecfe); 
    @include text-colors ('purple', #6F3E90, #E8DAEF); 

}

label {
    margin-bottom: 0.1rem  !important;
}

.label-color {   
    @include text-colors ('green', #55ce63, #e8fdeb);
    @include text-colors ('none', #080808, transparent);
    @include text-colors ('red', #f62d51, #f9e7eb);    
}
</style>

        